import { useState, useRef, useEffect } from 'react';

export const useExport = (postsFiltrados, comentariosExibidos, aggregatedMetrics, pageMetrics, pages, keywordsData) => {
    const [showExportMenu, setShowExportMenu] = useState(false);
    const exportRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (exportRef.current && !exportRef.current.contains(event.target)) {
                setShowExportMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const safeText = (text) => {
        if (!text) return "";
        const clean = String(text).replace(/"/g, '""').replace(/(\r\n|\n|\r)/gm, " ");
        return `"${clean}"`;
    };

    const downloadCSV = (content, filename) => {
        const bom = "\uFEFF"; 
        const blob = new Blob([bom + content], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleExport = (type) => {
        setShowExportMenu(false); 
        let csvContent = "";
        let filename = "";
        const today = new Date().toISOString().split('T')[0];

        if (type === 'metrics') {
            filename = `Metricas_Por_Pagina_${today}.csv`;
            
            // 1. Cabeçalho da Tabela (Colunas)
            csvContent = "Pagina;Seguidores;Posts no Periodo;Alcance;Curtidas;Comentarios;Salvos;Compartilhamentos;Views + Plays\n";
            
            // 2. Iterar sobre cada página disponível para criar as linhas
            if (pages && pages.length > 0) {
                pages.forEach(page => {
                    // Filtra apenas os posts desta página específica que estão dentro do filtro de data global
                    const postsDaPagina = postsFiltrados.filter(p => p.page_id === page.page_id);
                    
                    // Calcula as métricas somadas APENAS para esta página
                    const stats = postsDaPagina.reduce((acc, p) => {
                        acc.likes += p.like_count || 0;
                        acc.comments += p.comment_count || 0;
                        acc.shares += p.share_count || 0;
                        acc.saves += p.save_count || 0;
                        acc.reach += p.reach || 0;
                        acc.views += (p.view_count || p.video_view_count || 0) + (p.play_count || 0);
                        return acc;
                    }, { likes: 0, comments: 0, shares: 0, saves: 0, reach: 0, views: 0 });

                    // Monta a linha do CSV
                    csvContent += `${safeText(page.name)};`; // Nome da Página
                    csvContent += `${page.followers_count || 0};`; // Seguidores (Snapshot atual)
                    csvContent += `${postsDaPagina.length};`; // Quantidade de Posts no período
                    csvContent += `${stats.reach};`;
                    csvContent += `${stats.likes};`;
                    csvContent += `${stats.comments};`;
                    csvContent += `${stats.saves};`;
                    csvContent += `${stats.shares};`;
                    csvContent += `${stats.views}\n`;
                });
            }
        } 
        else if (type === 'posts') {
            // ... (Manter igual ao anterior)
            filename = `Lista_Posts_${today}.csv`;
            csvContent = "ID;Pagina;Data;Tipo;Legenda;Curtidas;Comentarios;Alcance;Salvos;Views;Plays\n";
            postsFiltrados.forEach(p => {
                // Opcional: Adicionar nome da página aqui também ajuda
                const pageName = pages ? pages.find(pg => pg.page_id === p.page_id)?.name || "N/A" : "N/A";
                const dateSafe = p.timestamp ? new Date(p.timestamp).toLocaleDateString('pt-BR') : "";
                csvContent += `${p.post_id};${safeText(pageName)};${dateSafe};${p.media_product_type || 'FEED'};${safeText(p.caption)};${p.like_count};${p.comment_count};${p.reach || 0};${p.save_count || 0};${p.view_count || p.video_view_count || 0};${p.play_count || 0}\n`;
            });
        } 
        else if (type === 'comments') {
            // ... (Manter igual ao anterior com a correção do caption)
            filename = `Lista_Comentarios_${today}.csv`;
            csvContent = "Post ID;Legenda Post;Comentario;Data;Classificacao\n";
            comentariosExibidos.forEach(c => {
                const postPai = postsFiltrados.find(p => p.post_id === c.post);
                const captionReal = postPai && postPai.caption ? postPai.caption : "Post sem legenda/não listado";
                const dateSafe = c.timestamp ? new Date(c.timestamp).toLocaleString('pt-BR') : "";
                csvContent += `${c.post};${safeText(captionReal)};${safeText(c.comment)};${dateSafe};${c.classification}\n`;
            });
        }
                else if (type === 'keywords') {
            filename = `Analise_Topicos_${today}.csv`;
            csvContent = "Palavra-Chave;Ocorrencias\n";
            
            if (keywordsData && keywordsData.length > 0) {
                keywordsData.forEach(k => {
                    csvContent += `${safeText(k.keyword)};${k.count}\n`;
                });
            } else {
                csvContent += "Nenhum tópico encontrado para o período.;0\n";
            }
        }
        downloadCSV(csvContent, filename);
    };

    return { showExportMenu, setShowExportMenu, exportRef, handleExport };
};